// enum DocusignAuthServer { DEMO = 'account-d.docusign.com', PRODUCTION = 'account.docusign.com', STAGING = 'account-s.docusign.com' }
export enum DocusignAuthServer {
  DEMO = 'DEMO',
  PRODUCTION = 'PRODUCTION',
  STAGING = 'STAGING',
}
